import { render, staticRenderFns } from "./newsRelease.vue?vue&type=template&id=ad0acf6e&"
import script from "./newsRelease.vue?vue&type=script&lang=js&"
export * from "./newsRelease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports